import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import { useIntl } from 'react-intl';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import Card from 'components/core/Card';
// HOCs
import withConfirmDialog from 'hocs/WithConfirmDialog';
// Models
import mCarpark from 'models/cpm/carpark';
// Custom
import { cpmTriggerCarparkDoor } from 'actions';
import {
  cpmDoorDataShape, errorShape, cpmEventDataShape, cpmOperationDataShape,
} from 'constants/PropTypesShapes';
import FormDialogTemplate from 'components/templates/FormDialogTemplate';
import FormHelper from 'components/misc/FormHelper';
import CarparkDoorItem from 'cpmCarparks/assets/main/CarparkDoorItem';
import CarparkDoorTriggerButton from 'cpmCarparks/assets/main/CarparkDoorTriggerButton';
// Toast
import { useToast } from 'components/toast/Toast';
// Events listener hook
import useEventsListener from 'cpmCarparks/routes/show/routes/equipments/hooks/useEventsListener';

// Wrapper component to use hooks
const OnDemandOpenDoorWrapper = (props) => {
  const { formatMessage: t } = useIntl();
  const { showToast } = useToast();
  return <OnDemandOpenDoor {...props} formatMessage={t} showToast={showToast} />;
};

class OnDemandOpenDoor extends React.Component {
  constructor(props) {
    super(props);
    this.handleTrigger = this.handleTrigger.bind(this);
  }

  componentDidMount() {
    const { onRef } = this.props;
    onRef(this);
  }

  handleTrigger(door) {
    const { id, handleTriggerDoor } = this.props;
    handleTriggerDoor({ carparkId: id, id: door.id }, door);

    if (this.props.showToast) {
      this.props.showToast({
        message: this.props.formatMessage({ id: 'notification.doorTriggerAsk' }),
        type: 'info',
      });
    }
  }

  render() {
    const {
      doors, errors, events, operations,
    } = this.props;

    // Filter events and operations for doors in this carpark
    const carparkEvents = events
      ? events.filter((e) => e.data && e.data.door && e.data.door.id && doors.some((d) => d.id === e.data.door.id))
      : [];

    const carparkOperations = operations
      ? operations.filter((op) => carparkEvents.some((e) => e.data && e.data.operationId === op.id))
      : [];

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <div className="d-flex">
              <FormHelper
                elements={[{
                  content: <LocalizedMessage id="help.onDemand.formOpenDoor" />,
                }]}
              />
              <div style={{ flex: 1 }}>
                <Card>
                  <div className="row information-item-wrapper">
                    {_map(mCarpark.sortDoors(doors), (door) => (
                      <div key={door.id} className="col-12">
                        <CarparkDoorItem
                          lightMode={false}
                          withShadow={false}
                          door={door}
                          action={(
                            <CarparkDoorTriggerButton
                              type="contained"
                              door={door}
                              onTrigger={() => this.handleTrigger(door)}
                            />
                          )}
                        />
                      </div>
                    ))}
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
        <EventsListenerWrapper
          events={carparkEvents}
          operations={carparkOperations}
          showToast={this.props.showToast}
        />
      </FormDialogTemplate>
    );
  }
}

// Wrapper component to use the useEventsListener hook
const EventsListenerWrapper = ({ events, operations, showToast }) => {
  useEventsListener({ events, operations, showToast });
  return null;
};

EventsListenerWrapper.propTypes = {
  events: PropTypes.arrayOf(cpmEventDataShape),
  operations: PropTypes.arrayOf(cpmOperationDataShape),
  showToast: PropTypes.func,
};

EventsListenerWrapper.defaultProps = {
  events: [],
  operations: [],
  showToast: () => {},
};

OnDemandOpenDoor.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  doors: PropTypes.arrayOf(cpmDoorDataShape).isRequired,
  operationError: errorShape, // eslint-disable-line react/no-unused-prop-types
  errors: PropTypes.object,
  onRef: PropTypes.func.isRequired,
  handleTriggerDoor: PropTypes.func.isRequired,
  formatMessage: PropTypes.func,
  showToast: PropTypes.func,
  events: PropTypes.arrayOf(cpmEventDataShape),
  operations: PropTypes.arrayOf(cpmOperationDataShape),
};

OnDemandOpenDoor.defaultProps = {
  operationError: null,
  errors: null,
  formatMessage: () => '',
  showToast: () => {},
  events: [],
  operations: [],
};

const mapDispatchToProps = (dispatch) => ({
  handleTriggerDoor: (data, door) => {
    dispatch(cpmTriggerCarparkDoor(mCarpark.mutTriggerDoor, data, door));
  },
});

const mapStateToProps = (state) => ({
  events: state.cpmEvent.list,
  operations: state.cpmOperation.list,
});

module.exports = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withConfirmDialog,
)(OnDemandOpenDoorWrapper);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/onDemand/OnDemandOpenDoor.js